package com.xtream.composeapp.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.data_kmp.remote.repo.DeviceInfo
import com.xtream.video_player.isWebOS

@Composable
actual fun getDeviceInfo(): DeviceInfo {
    // Initialize with a loading or fallback state
    var deviceInfo by remember {
        mutableStateOf(DeviceInfo("Loading...", "00:00:00:00:00:00", "webOS App", "0", versionName =SharedBuildKonfig.VERSION_NAME, deviceName = "Unknown"))
    }

    LaunchedEffect(Unit) {

            when {
                isWebOS() -> fetchNativeWebOSInfo { mac, model, version ->
                    deviceInfo = DeviceInfo(
                        deviceId = mac.replace(":", ""),
                        macAddress = mac,
                        model = "webOS",
                        firmwareVersion = version,
                        versionName = SharedBuildKonfig.VERSION_NAME,
                        deviceName = model // modelName from webOS deviceInfo e.g. "OLED55C2"
                    )
                }
                /*isTizen() -> fetchNativeTizenInfo { mac, model, version ->
                    deviceInfo = DeviceInfo(
                        deviceId = mac.replace(":", ""),
                        macAddress = mac,
                        model = "Tizen",
                        firmwareVersion = version,
                        versionName = SharedBuildKonfig.VERSION_NAME,
                        deviceName = model // from tizen.systeminfo or webapis.productinfo
                    )
                }*/
                else -> {
                    deviceInfo = DeviceInfo(
                        deviceId = "000000000000",
                        macAddress = "00:00:00:00:00:00",
                        model = "Browser",
                        firmwareVersion = "1.0",
                        versionName = SharedBuildKonfig.VERSION_NAME,
                        deviceName = "Browser Preview"
                    )

                }
        }
    }

    return deviceInfo
}

// Low-level JS interop execution block
private fun fetchNativeWebOSInfo(onReady: (mac: String, model: String, version: String) -> Unit) {
    js("""
        if (typeof window.webOS !== 'undefined') {
            window.webOS.service.request("luna://com.webos.service.connectionmanager", {
                method: "getinfo",
                parameters: {},
                onSuccess: function(result) {
console.log("getinfo success:", JSON.stringify(result));
                    var finalMac = "00:11:22:33:44:55";
                    if (result.wiredInfo && result.wiredInfo.macAddress) {
                        finalMac = result.wiredInfo.macAddress;
                    } else if (result.wifiInfo && result.wifiInfo.macAddress) {
                        finalMac = result.wifiInfo.macAddress;
                    }
                    
                    // Fetch device details as well
                    window.webOS.deviceInfo(function(info) {
                        onReady(finalMac, info.modelName || "webOS TV", info.version || "Unknown");
                    });
                },
                onFailure: function(err) {

                    // Fallback configuration if getinfo fails but webOS wrapper exists
                    window.webOS.deviceInfo(function(info) {
                           console.log("getinfo err for " + info.modelName + ":", JSON.stringify(err));
 onReady("00:00:00:00:00:00", info.modelName || "webOS TV", info.version || "Unknown");
                    });
                }
            });
        } else {
            // Standard PC browser sandbox alternative fallback
            onReady("00:10:20:30:40:50", "Browser Preview", "1.0");
        }
    """)
}